import React, { useState } from "react"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import ReasonDialog from "./reason-dialog"
import PriceDialog from "./price-dialog"
import SupportDialog from "./support-dialog"
import FeedbackDialog from "./feedback-dialog"
import ConfirmCancellationDialog from "./confirm-dialog"
import SuccessDialog from "./success-dialog"

const CancellationFlow = ({ isOpen, onClose, subscription }) => {
  const [step, setStep] = useState("reason")
  const [reason, setReason] = useState(null)
  const [feedback, setFeedback] = useState("")
  const texts = TextBundle({ id: "aldoo_ra_cancel_flow" })

  const handleClose = () => {
    setStep("reason")
    setReason(null)
    setFeedback("")
    onClose()
  }

  if (!isOpen) return null

  if (step === "reason")
    return (
      <ReasonDialog
        isOpen={isOpen}
        onClose={handleClose}
        texts={texts}
        onNext={(selectedReason) => {
          setReason(selectedReason)
          if (selectedReason === "price") setStep("price")
          else if (selectedReason === "technical") setStep("technical")
          else setStep("feedback")
        }}
      />
    )

  if (step === "price")
    return (
      <PriceDialog
        isOpen={isOpen}
        onClose={handleClose}
        texts={texts}
        onContinue={() => setStep("confirm")}
      />
    )

  if (step === "technical")
    return (
      <SupportDialog
        isOpen={isOpen}
        onClose={handleClose}
        texts={texts}
        onContinue={() => setStep("confirm")}
      />
    )

  if (step === "feedback")
    return (
      <FeedbackDialog
        isOpen={isOpen}
        onClose={handleClose}
        texts={texts}
        onContinue={(feedbackText) => {
          setFeedback(feedbackText)
          setStep("confirm")
        }}
      />
    )

  if (step === "confirm")
    return (
      <ConfirmCancellationDialog
        isOpen={isOpen}
        onClose={handleClose}
        texts={texts}
        subscription={subscription}
        reason={reason}
        feedback={feedback}
        onConfirm={() => setStep("success")}
      />
    )

  if (step === "success")
    return <SuccessDialog isOpen={isOpen} onClose={handleClose} texts={texts} />

  return null
}

export default CancellationFlow
